import { createSlice } from '@reduxjs/toolkit';

type ModalState = {
	modal: boolean,
};

const initialState: ModalState = {
	modal: false,
};

const slice = createSlice({
	name: 'modal',
	initialState,
	reducers: {
		handleOpenModal(state) {
			state.modal = true;
		},
		handleCloseModal(state) {
			state.modal = false;
		},
	},
});

export const { handleOpenModal, handleCloseModal } = slice.actions;

export default slice.reducer;